export default "__VITE_ASSET__QP84inbu__"